
<div class="container mt-5">
  <div class="row">
    <div class="col">

      <markdown [data]="markdownContent"></markdown>

      <!-- <h3 class="mb-5">{{ "faqs.title" | translate }}<br><small>{{ "faqs.subtitle" | translate: {program: programName} }}</small></h3>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-1.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-1.a-1" | translate: {program: programName} }}</li>
            <li *ngIf="!faqsGuatemala">{{ "faqs.q-1.a-2" | translate }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-2.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-2.a-1" | translate: {program: programName} }}</li>
            <li *ngIf="!faqsGuatemala">{{ "faqs.q-2.a-2-1" | translate }}</li>
            <li *ngIf="faqsGuatemala">{{ "faqs.q-2.a-2-2" | translate }}</li>
            <li *ngIf="!faqsGuatemala">{{ "faqs.q-2.a-3-1" | translate }}
            <li *ngIf="faqsGuatemala">{{ "faqs.q-2.a-3-2" | translate }}
              <ol>
                <li *ngIf="!faqsGuatemala"><b>{{ "faqs.q-2.a-4-title" | translate }}</b> {{ "faqs.q-2.a-4" | translate }}</li>
                <li><b>{{ "faqs.q-2.a-5-title" | translate }}</b> <span *ngIf="!faqsGuatemala"> {{ "faqs.q-2.a-5-1" | translate }}</span><span *ngIf="faqsGuatemala"> {{ "faqs.q-2.a-5-2" | translate }}</span></li>
                <li *ngIf="!faqsGuatemala"><b>{{ "faqs.q-2.a-6-title" | translate }}</b> {{ "faqs.q-2.a-6" | translate }}</li>
              </ol>
            </li>
          </ul>
      </ul>

      <ul *ngIf="cardPrice" class="list-unstyled">
        <li><h5>{{ "faqs.q-3.question" | translate }}</h5>
          <ul>
            <li *ngIf="this.configuration.hasCardPurchase && this.cardPrice != 0" >{{ "faqs.q-3.a-1_card_price" | translate: {price: cardPrice} }}</li>
            <li *ngIf="this.configuration.hasCardPurchase && this.cardPrice == 0">{{ "faqs.q-3.a-1_card_no_price" | translate }}</li>
            <li *ngIf="!this.configuration.hasCardPurchase">{{ "faqs.q-3.a-1_card_automatic" | translate: {price: cardPrice}  }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-4.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-4.a-1" | translate: {program: programName} }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-5.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-5.a-1" | translate }}</li>
            <li>{{ "faqs.q-5.a-2" | translate }}</li>
            <li *ngIf="faqsConfig1">{{ "faqs.q-5.a-3_1" | translate: {program: programName} }}</li>
            <li *ngIf="!faqsConfig1">{{ "faqs.q-5.a-3_2" | translate: {program: programName} }}</li>
            <li>{{ "faqs.q-5.a-4" | translate }}</li>
            <li>{{ "faqs.q-5.a-5" | translate }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-6.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-6.a-1" | translate }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-7.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-7.a-1" | translate }}</li>
            <li>{{ "faqs.q-7.a-2" | translate }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-8.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-8.a-1" | translate }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-9.question" | translate: {program: programName} }}</h5>
          <ul>
            <li>{{ "faqs.q-9.a-1" | translate: {program: programName} }}</li>
          </ul>
      </ul>

      <ul *ngIf="!faqsConfig1" class="list-unstyled">
        <li><h5>{{ "faqs.q-10.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-10.a-1" | translate: {program: programName} }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-11.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-11.a-1" | translate: {program: programName} }}</li>
            <li>{{ "faqs.q-11.a-2" | translate: {webpage: webpage} }}</li>
            <li>{{ "faqs.q-11.a-3" | translate: {callCenter: configuration.callCenterNumber} }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-12.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-12.a-1" | translate: {program: programName, callCenter: configuration.callCenterNumber} }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-13.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-13.a-1" | translate: {callCenter: configuration.callCenterNumber} }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-14.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-14.a-1" | translate }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-15.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-15.a-1" | translate }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-16.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-16.a-1" | translate: {program: programName, callCenter: configuration.callCenterNumber} }}</li>
            <li>{{ "faqs.q-16.a-2" | translate }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-17.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-17.a-1" | translate: {program: programName} }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-18.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-18.a-1" | translate }}</li>
          </ul>
      </ul>

      <ul class="list-unstyled">
        <li><h5>{{ "faqs.q-19.question" | translate }}</h5>
          <ul>
            <li>{{ "faqs.q-19.a-1" | translate }}</li>
          </ul>
      </ul> -->

    </div>
  </div>
</div>